import { Stack, Typography } from '@mui/material'
import { Color } from '../../../../../../chess/types'
import { useScreenSize } from '../../../../../../sharedComponents/src/hooks/useScreenSize'
import { DialogDataEntry } from '../../utils'

type IProps = {
    myColor?: Color
    gameOverData: DialogDataEntry
}

export const GameOverDescription: React.FC<IProps> = ({ myColor, gameOverData }) => {
    const { isMobile } = useScreenSize()
    const gameResultDescription = (myColor === undefined && gameOverData.neutralDescription) || gameOverData.description

    return (
        <Stack spacing={1} alignItems="center">
            <Typography variant={isMobile ? 'body2' : 'body1'}>{gameResultDescription}</Typography>
        </Stack>
    )
}
